<template>
    <v-footer class="esenda-footer">
        <v-row class="align-center justify-center">
            <v-col cols="12" xs="12">
                <img alt="Esenda logo" :src="poweredByLogo" width="120" />

                <div>
                    <a
                        href="https://payment.esenda.com/terms-and-conditions"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Terms And Conditions
                    </a>
                    •
                    <a
                        href="https://payment.esenda.com/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Privacy Policy
                    </a>
                </div>
            </v-col>
        </v-row>
    </v-footer>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useCheckoutTheme } from "@/theme/applyCheckoutTheme";
import { getContrastRatio } from "@/theme/checkoutTheme";
import poweredByDark from "@/assets/logos/powered_by_dark.svg";
import poweredByLight from "@/assets/logos/powered_by_light.svg";

const NAVY = "#040a4e";
const WHITE = "#ffffff";

const checkoutTheme = useCheckoutTheme();

const poweredByLogo = computed(() => {
    const background = checkoutTheme?.pageBackground;
    if (!background) {
        return poweredByDark;
    }
    return getContrastRatio(WHITE, background) >
        getContrastRatio(NAVY, background)
        ? poweredByLight
        : poweredByDark;
});
</script>

<style scoped>
.esenda-footer {
    width: 100%;
    text-align: center;
    padding: 0;
    font-size: 0.8rem !important;
    background-color: var(--background-color);
}

.esenda-footer .v-col {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    max-width: 600px;
}

.esenda-footer .v-col div {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
}

.esenda-footer a {
    display: inline-flex;
    font-size: 0.75rem;
    text-decoration: underline;
    color: var(--text-secondary);
}

@media (min-width: 624px) {
    .esenda-footer .v-col {
        flex-direction: row;
        align-items: flex-end;
    }
}
</style>
